/**
 * Links a Button RWD (href="#your-id") with the catalog tab using the same ID.
 * This asset is loaded only on the page.catalog template.
 */
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('collection-tabs-rwd [role="tab"][id]');

  tabs.forEach((tab) => {
    if (!(tab instanceof HTMLButtonElement)) return;

    const sourceButtons = [...document.querySelectorAll('a[href^="#"]')].filter(
      (link) => link instanceof HTMLAnchorElement && decodeURIComponent(link.hash.slice(1)) === tab.id
    );
    const catalogTabs = tab.closest('collection-tabs-rwd');

    if (!catalogTabs || typeof catalogTabs.switchTab !== 'function' || sourceButtons.length === 0) return;

    sourceButtons.forEach((sourceButton) => {
      sourceButton.addEventListener('click', (event) => {
        event.preventDefault();
        catalogTabs.switchTab(tab);

        requestAnimationFrame(() => {
          const header = document.querySelector('#header-group');
          const headerOffset = header instanceof HTMLElement ? header.getBoundingClientRect().height : 0;
          const spacing = 40;
          const targetTop = window.scrollY + catalogTabs.getBoundingClientRect().top - headerOffset - spacing;

          window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
        });
      });
    });
  });
});
